import {Controller} from "@hotwired/stimulus";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'my-tools-modal',
    ];

    openModal(event) {
        if (event) {
            event.preventDefault();
        }

        this.myToolsModalOutlet.open();
    }
}
